// This file was auto-generated by @insertish/oapi!
export const defaultBaseURL = "https://api.revolt.chat";
